import React, { Component } from 'react';

export default class ConfirmMessage extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	};

	render() {
		let style = {
			position: 'absolute',
			background: '#b8cde354',
			top: this.props.top != null ? this.props.top : 0,
			right: 10
		}

		style = Object.assign(style, this.props.style);

		return (
			<div id='site_name' style={style}>
				<span className='footnote' style={{ fontSize: 14 }}>{this.props.site_name}</span>
			</div>
		);
	}
}